import {Controller} from "@hotwired/stimulus"

class FadingBannerController extends Controller {
  connect() {
    this.timeout = setTimeout(() => this.show(), 5 * 1000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  show() {
    if (this.banner_is_hidden) return

    this.element.classList.add("fading-banner-promote")
  }

  hide() {
    this.element.classList.remove("fading-banner-promote")
    this.banner_is_hidden = true
  }
}

export default FadingBannerController
